import $ from 'jquery';
import Backbone from 'backbone';
import Dropdown from 'bootstrap/js/dist/dropdown';

export default Backbone.View.extend({

  initialize: function() {
    this.embed_width_field = this.$el.find("input#width");
    this.embed_auto_width = this.$el.find('input#auto-width');
    this.embed_include_description = this.$el.find('input#description');
    this.render();
  },

  events: {
    "keyup input#width" : "generate_embed_code",
    "change input#description" : "generate_embed_code",
    "change input#auto-width" : "generate_embed_code",
    "click .embed-tab-handle": "generate_embed_code",
    "click .btn-close": "close",
  },

  defaultOptions: {
    width: "600"
  },

  rootUrl: `${window.location.protocol}//${window.location.host}`,
  brandedFooterHeight: 38,

  render: function() {
    // Generate embed code on display to account of current size of chart.
    this.dropdownToggleEl = document.getElementById('share-dropdown-toggle');
    this.dropdownToggleEl.addEventListener('show.bs.dropdown', () => {
      this.generate_share_embed_text();
    });
  },

  update_model: function(new_model) {
    if (new_model != undefined) {
      this.model = new_model;
    }

    this.generate_share_embed_text();
  },

  generate_share_embed_text: function() {
    this.generate_share_text();
    this.generate_embed_code();
  },

  generate_share_text: function() {
    this.$el.find("input#share-link").val(`${this.rootUrl}/data/${this.model.get("id")}`);
  },

  generate_embed_code: function() {
    const id = this.model.get("id");
    let width = this.defaultOptions.width + 'px';
    let widgetUrl = `${this.rootUrl}/data/widgets/${id}`;

    const chartContainerEl = document.querySelector('.chart-container')
    let height = chartContainerEl.offsetHeight + this.brandedFooterHeight;

    if (this.embed_auto_width.prop("checked")) {
      this.embed_width_field.attr("disabled", "disabled");
      width = chartContainerEl.offsetWidth + 'px';
      $('.hidden-chart-description').width(width);
    }
    else {
      this.embed_width_field.removeAttr("disabled");
      width = parseInt(this.embed_width_field.val()) || this.defaultOptions.width;
      width += 'px';
    }
    $('.hidden-chart-description').width(width);

    if (this.embed_include_description.prop("checked")) {
      $('.hidden-chart-description p').show();
    } else {
      $('.hidden-chart-description p').hide();
      widgetUrl += "?chart_only=true";
    }

    // Subtract the visible chart description from the height, and add back in
    // the hidden chart description (which has been resized for the expected
    // width).
    height -= document.querySelector('.chart-description').offsetHeight;
    height += $('.hidden-chart-description').height();
    height = Math.ceil(height);

    var embedCode = "<iframe style=\"width: " + width + "; height: " + height + "px;\" " +
      "src=\"" + widgetUrl + "\" " +
      "frameborder=\"0\" marginwidth=\"0\" marginheight=\"0\" " +
      "scrolling=\"no\">" +
      "</iframe>";

    this.$el.find("textarea#embed-code").text(embedCode);
  },

  close() {
    const dropdown = Dropdown.getInstance(this.dropdownToggleEl);
    dropdown.hide();
  },
});
